import { combineReducers } from "redux";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { FETCH_MESSAGES_REQUEST } from "./constants";
import { Action, MessagesState } from "./types";

const initialState: MessagesState = {
  currentPage: 0,
  pageCount: 1,
  count: 0,
  data: [],
};

function items(state: MessagesState = initialState, action: Action): MessagesState {
  switch (action.type) {
    case getSuccessActionType(FETCH_MESSAGES_REQUEST):
      return { ...action.payload, data: [...state.data, ...action.payload.data] };
    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_MESSAGES_REQUEST:
      return true;
    case getSuccessActionType(FETCH_MESSAGES_REQUEST):
    case getFailureActionType(FETCH_MESSAGES_REQUEST):
      return false;
    default:
      return state;
  }
}

export const messages = combineReducers({ items, isFetching });
